import Swiper from 'swiper';
import { debounce } from 'lodash-es'

document.addEventListener('DOMContentLoaded', function() {
	const swiperEls = document.getElementsByClassName('sectionFeaturedProductsFilter__swiper');

	if (!swiperEls.length) {
		return;
	}

	const swiper = new Swiper('.sectionFeaturedProductsFilter__swiper', {
		centeredSlides: false,
		loop: false,
		spaceBetween: 0,
		touchEventsTarget: 'container',
		slidesPerView: 1.1,
		navigation: {
			nextEl: '.sectionFeaturedProductsFilter__swiper-button-next',
			prevEl: '.sectionFeaturedProductsFilter__swiper-button-prev',
		},
		virtual: {
			slides: (function () {
				const placeholder = '<div class="garageCell garageCell--placeholder">'
					+ '<div class="garageCell__image garageCell__image--placeholder"></div>'
					+ '<div class="garageCell__header garageCell__header--placeholder">'
					+ '<div class="garageCell__title garageCell__title--placeholder"></div>'
					+ '<div class="garageCell__meta garageCell__meta--placeholder"></div>'
					+ '</div>'
					+ '<div class="garageCell__button garageCell__button--placeholder"></div>'
					+ '</div>';
				const slides = [];
				for (var i = 0; i < 10; i += 1) {
					slides.push(placeholder);
				}
				return slides;
			})(),
		},
		breakpointsBase: 'container',
		breakpoints: {
			700: {
				slidesPerView: 2.1,
			},
			950: {
			  slidesPerView: 3.1,
			},
			1200: {
			  slidesPerView: 3.1,
			},
			1600: {
			  slidesPerView: 4.1,
			},
			2000: {
				slidesPerView: 5.1,
			},
			2400: {
				slidesPerView: 6.1,
			},
		},
		threshold: 2,
	});

	jQuery( '.sectionFeaturedProductsFilter .taxonomy-filter__select select' ).on( 'change', function () {
		const form = jQuery( this ).closest( 'form' );

		const isTargeted = form.data('is-targeted');

		if (isTargeted) {
			return;
		}

		swiper.virtual.update()
|
		jQuery.ajax( {
			url: form.attr('action'),
			data: form.serialize(),
			type: 'GET',
			success: function ( data ) {
				swiper.virtual.removeAllSlides()

				if (data.length) {
					swiper.virtual.appendSlide(data);
				} else {
					swiper.virtual.appendSlide(['<div class="swiper-slide">Ingen treff.</div>']);
				}
			}
		} );
	} ).first().trigger( 'change' ); // Fire change event only once on load.

	const swiperUpdate = () => {
		swiper.virtual.update();
	}

	const debounceSwiperUpdate = debounce(swiperUpdate, 250, { 'maxWait': 1000 })

	window.addEventListener('resize', debounceSwiperUpdate);
});
